import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind CSS class name utility function.
 * Merges class names and removes duplicates.
 *
 * @param inputs - Class names to merge.
 * @returns A single string with merged class names.
 *
 * @example
 * cn('bg-red-500', 'text-white', 'bg-red-500'); // returns 'bg-red-500 text-white'
 * cn('p-4', 'p-2', 'text-lg'); // returns 'p-4 text-lg'
 * cn('hidden', 'block', 'hidden'); // returns 'hidden block'
 *
 * This function is useful for dynamically constructing class names in React components,
 * ensuring that only unique class names are applied.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
